import * as React from "react";
/* empty css                     */
import { ProductBlockContainerLoader } from "../../../ProductBlockContainerLoader/ProductBlockContainers/ProductBlockContainerLoader/ProductBlockContainerLoader.js";
const ProductBlockRow = ({
  isLoading,
  children
}) => {
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(ProductBlockContainerLoader, null);
  }
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-row" }, children);
};
export {
  ProductBlockRow
};
//# sourceMappingURL=ProductBlockRow.js.map
